import { render } from "./baochuan.vue?vue&type=template&id=0ff96694"
import script from "./baochuan.vue?vue&type=script&lang=js"
export * from "./baochuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__